import { useSyncExternalStore } from 'react';
import type { ThemeChoice } from './theme-choice';
import { themeStore } from './theme-store';

type Theme = {
  readonly choice: ThemeChoice;
  readonly resolved: 'light' | 'dark';
};

export function useTheme(): Theme {
  const choice = useSyncExternalStore(themeStore.subscribe, themeStore.read);
  return { choice, resolved: themeStore.resolved() };
}
